var _style, _path, _path2, _path3, _path4, _circle, _path5, _rect, _circle2, _rect2, _circle3, _path6, _circle4, _circle5, _circle6, _circle7, _path7, _path8, _polygon, _path9, _polygon2, _path10, _circle8, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a87032b8-5b37-4b7e-a4d9-4dbfbe394641",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 744.8 747.1",
    style: {
      enableBackground: "new 0 0 744.8 747.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6E6E6;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#CCCCCC;}\r\n\t.st3{fill:#6C63FF;}\r\n\t.st4{fill:#3F3D56;}\r\n\t.st5{fill:#FFB8B8;}\r\n\t.st6{fill:#2F2E41;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b3ac2088-de9b-4f7f-bc99-0ed9705c1a9d",
    className: "st0",
    d: "M519.8,177h-4.1V64.9c0-35.8-29-64.9-64.9-64.9H213.3 c-35.8,0-64.9,29-64.9,64.9v615c0,35.8,29,64.9,64.9,64.9h237.5c35.8,0,64.9-29,64.9-64.9V256.8h4.1L519.8,177z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b2715b96-3117-487c-acc0-20904544b5b7",
    className: "st1",
    d: "M453.4,16.9h-31c4.8,11.8-0.8,25.2-12.6,30 c-2.8,1.1-5.7,1.7-8.7,1.7H265c-12.7,0-23-10.3-23-23c0-3,0.6-5.9,1.7-8.7h-29c-26.8,0-48.5,21.7-48.5,48.5l0,0v614.1 c0,26.8,21.7,48.5,48.5,48.5h238.7c26.8,0,48.5-21.7,48.5-48.5l0,0V65.3C501.8,38.6,480.2,16.9,453.4,16.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b06d66ec-6c84-45dd-8c27-1263a6253192",
    className: "st2",
    d: "M303.7,261.5c0-8.7,4.7-16.8,12.2-21.2c-11.7-6.8-26.6-2.7-33.4,8.9 c-6.8,11.7-2.7,26.6,8.9,33.4c7.6,4.4,16.9,4.4,24.5,0C308.3,278.3,303.7,270.2,303.7,261.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "e73810fe-4cf4-40cc-8c7c-ca544ce30bd4",
    className: "st2",
    d: "M334.4,261.5c0-8.7,4.7-16.8,12.2-21.2c-11.7-6.8-26.6-2.7-33.4,8.9 c-6.8,11.7-2.7,26.6,8.9,33.4c7.6,4.4,16.9,4.4,24.5,0C339.1,278.3,334.4,270.2,334.4,261.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a4813fcf-056e-4514-bb8b-e6506f49341f",
    className: "st3",
    cx: 364.4,
    cy: 261.5,
    r: 24.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "bbe451c3-febc-41ba-8083-4c8307a2e73e",
    className: "st2",
    d: "M405.3,337.9H262.8c-2.8,0-5.1-2.3-5.1-5.1V190.3 c0-2.8,2.3-5.1,5.1-5.1h142.5c2.8,0,5.1,2.3,5.1,5.1v142.5C410.4,335.6,408.1,337.9,405.3,337.9z M262.8,187.2 c-1.7,0-3.1,1.4-3.1,3.1v142.5c0,1.7,1.4,3.1,3.1,3.1h142.5c1.7,0,3.1-1.4,3.1-3.1V190.3c0-1.7-1.4-3.1-3.1-3.1H262.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bb28937d-932f-4fdf-befe-f406e51091fe",
    x: 218.6,
    y: 447.1,
    className: "st2",
    width: 218.6,
    height: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "fcef55fc-4968-45b2-93bb-1a1080c85fc7",
    className: "st3",
    cx: 225.5,
    cy: 427.4,
    r: 6.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "ff33d889-4c74-4b91-85ef-b4882cc8fe76",
    x: 218.6,
    y: 516.1,
    className: "st2",
    width: 218.6,
    height: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "e8fa0310-b872-4adf-aedd-0c6eda09f3b8",
    className: "st3",
    cx: 225.5,
    cy: 496.4,
    r: 6.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M433.1,594.7H364c-2.5,0-4.5-2-4.5-4.5V566c0-2.5,2-4.5,4.5-4.5h69.1c2.5,0,4.5,2,4.5,4.5v24.2 C437.6,592.7,435.6,594.7,433.1,594.7z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "e12ee00d-aa4a-4413-a013-11d20b7f97f7",
    className: "st3",
    cx: 248,
    cy: 427.4,
    r: 6.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "f58f497e-6949-45c8-be5f-eee2aa0f6586",
    className: "st3",
    cx: 270.5,
    cy: 427.4,
    r: 6.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "b4d4939a-c6e6-4f4d-ba6c-e8b05485017d",
    className: "st3",
    cx: 248,
    cy: 496.4,
    r: 6.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "aff120b1-519b-4e96-ac87-836aa55663de",
    className: "st3",
    cx: 270.5,
    cy: 496.4,
    r: 6.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "f1094013-1297-477a-ac57-08eac07c4bd5",
    className: "st4",
    d: "M742.1,747.1h-718c-1.5,0-2.8-0.5-2.8-1.2s1.2-1.2,2.8-1.2h718 c1.5,0,2.8,0.5,2.8,1.2S743.6,747.1,742.1,747.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M564.7,489.5c0.5,0.2,1,0.5,1.4,0.8l44.9-19.1l1.6-11.8l17.9-0.1l-1.1,27.1l-59.2,15.7 c-0.1,0.4-0.3,0.8-0.4,1.2c-2.4,5.1-8.5,7.3-13.6,4.9c-5.1-2.4-7.3-8.5-4.9-13.6C553.6,489.4,559.6,487.2,564.7,489.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "637,735 624.7,735 618.9,687.7 637,687.7 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M616,731.5h23.6l0,0v14.9l0,0h-38.5l0,0l0,0C601.1,738.2,607.7,731.5,616,731.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "684.7,731.6 672.5,732.8 662,686.3 680,684.5 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M663.4,730.1l23.5-2.3l0,0l1.5,14.8l0,0l-38.3,3.8l0,0l0,0C649.2,738.2,655.2,730.9,663.4,730.1z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 640.4,
    cy: 384.6,
    r: 24.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M622,725.5c-2.2,0-4-1.6-4.4-3.7c-6.3-35.2-27.1-150.4-27.6-153.6c0-0.1,0-0.1,0-0.2v-8.6 c0-0.3,0.1-0.6,0.3-0.9l2.7-3.8c0.3-0.4,0.7-0.6,1.1-0.6c15.6-0.7,66.8-2.9,69.3,0.2l0,0c2.5,3.1,1.6,12.5,1.4,14.4l0,0.2l23,147 c0.4,2.4-1.3,4.7-3.7,5.1l-14.4,2.4c-2.2,0.4-4.3-1-5-3.1c-4.4-14.2-19.3-61.9-24.5-80.4c-0.1-0.3-0.3-0.4-0.6-0.3 c-0.2,0.1-0.4,0.3-0.4,0.5c0.3,17.6,0.9,62.5,1.1,78l0,1.7c0,2.3-1.8,4.3-4.1,4.5l-13.8,1.3C622.3,725.5,622.1,725.5,622,725.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "ae7af94f-88d7-4204-9f07-e3651de85c05",
    className: "st3",
    d: "M624.8,418.8c-4.3,2.5-6.9,7.2-8.3,12c-2.7,8.8-4.4,17.9-4.9,27.2 l-1.6,27.6l-19.3,73.2c16.7,14.1,26.3,10.9,48.8-0.6s25,3.9,25,3.9l4.5-62.3l6.4-68c-1.4-1.7-3.1-3.3-4.9-4.7 c-12-9.3-27.7-12.7-42.4-9L624.8,418.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M618.6,504.2c0.5,0.2,1,0.4,1.5,0.7l44.3-22.2l0.7-12l18.3-1.3l1,27.4l-59.3,19.6c-1.3,5.6-7,9.2-12.6,7.8 c-5.6-1.3-9.2-7-7.8-12.6c1.3-5.6,7-9.2,12.6-7.8C617.7,504,618.1,504.1,618.6,504.2L618.6,504.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "a6768b0e-63d0-4b31-8462-9b2e0b00f0fd",
    className: "st3",
    d: "M675.2,432c10.9,3.9,12.8,45.6,12.8,45.6 c-12.8-7.1-28.2,4.5-28.2,4.5s-3.2-10.9-7.1-25c-2.4-8.1-0.4-16.8,5.1-23.1C657.9,433.9,664.3,428.1,675.2,432z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "bfd7963f-0cf8-4885-9d3a-2c00bccda2e3",
    className: "st6",
    d: "M662.4,391.1c-3.1-2.4-7.2,2-7.2,2l-2.4-22c0,0-15.3,1.8-25.1-0.6 s-11.3,8.9-11.3,8.9c-0.5-4.6-0.6-9.2-0.3-13.8c0.6-5.5,8.6-11,22.6-14.7s21.4,12.2,21.4,12.2C669.9,368,665.5,393.5,662.4,391.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.a7a14c876921de46a2c28d153cc5d650.svg";
export { ForwardRef as ReactComponent };